export const DOCTOR_NOW_COMPANY_LATITUDE = 37.4995535963247;
export const DOCTOR_NOW_COMPANY_LONGITUDE = 127.025752388871;
